import { JIRA_AI_NATIVE_SIGNUP_SOURCE } from '@/components/user-context/helpers/cohorts';
import { experiments } from '@/utils/experiment/manifest';

import { queryParam, user, localStorageData } from '../../hooks/use-registered-metadata';

import {
	JTBD,
	PROVISIONING,
	ScreenConfig,
	TEAM_CHOICE,
	TEMPLATE_CHOICE,
	PROVISIONING_WITH_WIZARD,
	RESOLVE_TENANT_LOADER,
	CODING_AGENT_CHOICE,
} from './utils';

export const jiraScreenConfig: ScreenConfig = {
	[RESOLVE_TENANT_LOADER]: {
		position: { default: 50 },
		onMount: () => undefined,
		visibility: {
			default: true,
		},
	},
	[TEAM_CHOICE]: {
		position: { default: 100 },
		onMount: () => undefined,
		visibility: {
			default: false,
			conditionalOR: [
				{
					conditionalAND: [
						{
							key: queryParam.templateId,
							value: undefined,
						},
						{
							key: queryParam.products,
							value: ['jira-software.ondemand'],
						},
						{
							conditionalOR: [
								{
									conditionalAND: [
										{
											key: user.isN2n,
											value: true,
										},
									],
								},
								{
									conditionalAND: [
										{
											key: user.isExistingJiraUser,
											value: false,
										},
									],
								},
							],
						},
						{
							conditionalOR: [
								{
									conditionalAND: [
										{
											key: localStorageData.team,
											value: undefined,
										},
									],
								},
								{
									conditionalAND: [
										{
											key: localStorageData.team,
											value: '',
										},
									],
								},
							],
						},
					],
				},
			],
		},
	},
	[JTBD]: {
		position: { default: 190 },
		onMount: () => undefined,
		visibility: {
			default: false,
			conditionalOR: [
				{
					conditionalAND: [
						{
							key: user.isN2n,
							value: true,
						},
						{
							key: queryParam.jtbd,
							value: undefined,
						},
						{
							conditionalOR: [
								{
									conditionalAND: [
										{
											key: queryParam.products,
											value: ['jira-software.ondemand'],
										},
									],
								},
								{
									conditionalAND: [
										{
											key: queryParam.products,
											value: ['jira-core.ondemand'],
										},
									],
								},
							],
						},
						{
							key: queryParam.templateId,
							value: undefined,
						},
					],
				},
			],
		},
	},
	[TEMPLATE_CHOICE]: {
		position: { default: 200 },
		onMount: () => undefined,
		visibility: {
			default: false,
			conditionalOR: [
				{
					conditionalAND: [
						{
							key: queryParam.templateId,
							value: undefined,
						},
						{
							key: queryParam.templateChoice,
							value: undefined,
						},
						{
							key: queryParam.jtbd,
							value: undefined,
						},
						{
							key: queryParam.products,
							value: ['jira-software.ondemand'],
						},
					],
				},
			],
		},
	},
	[PROVISIONING]: {
		position: { default: 275 },
		onMount: () => undefined,
		visibility: {
			default: false,
			conditionalOR: [
				{
					conditionalAND: [
						{
							key: user.isMobile,
							value: true,
						},
						{
							key: queryParam.signupSource,
							value: undefined,
						},
					],
				},
			],
		},
	},
	[CODING_AGENT_CHOICE]: {
		position: { default: 285 },
		onMount: () => undefined,
		visibility: {
			default: false,
			conditionalOR: [
				{
					conditionalAND: [
						{
							key: queryParam.codingAgents,
							value: undefined,
						},
						{
							type: 'experiment',
							experiment: experiments.twcg1935CodingAgentChoice,
							value: true,
						},
					],
				},
				{
					conditionalAND: [
						{
							key: queryParam.codingAgents,
							value: undefined,
						},
						{
							key: queryParam.signupSource,
							value: JIRA_AI_NATIVE_SIGNUP_SOURCE,
						},
					],
				},
			],
		},
	},
	[PROVISIONING_WITH_WIZARD]: {
		position: { default: 300 },
		onMount: () => undefined,
		visibility: {
			default: false,
			conditionalOR: [
				{
					conditionalAND: [
						{
							key: user.isMobile,
							value: false,
						},
					],
				},
				{
					conditionalAND: [
						{
							key: user.isMobile,
							value: true,
						},
						{
							key: queryParam.signupSource,
							value: JIRA_AI_NATIVE_SIGNUP_SOURCE,
						},
					],
				},
			],
		},
	},
};
